import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getParams } from '../../common/common.func';
import { PagedList } from '../../common/common.types';
import { EventBase, EventBaseFilter, NewEventBase, UpdatedEventBase } from './event-base.types';

@Injectable()
export class EventBaseService {
	private eventBasesUrl = 'api/eventBases';

	constructor(private _http: HttpClient) { }

	getEventBases(filter?: EventBaseFilter): Promise<PagedList<EventBase>> {
		const options = { params: getParams(filter) };
		return this._http.get<PagedList<EventBase>>(this.eventBasesUrl, options).toPromise();
	}

	getEventBase(eventBaseId: number): Promise<EventBase> {
		return this._http.get<EventBase>(`${this.eventBasesUrl}/${eventBaseId}`).toPromise();
	}

	createEventBase(newEventBase: NewEventBase): Promise<number> {
		return this._http.post<number>(this.eventBasesUrl, newEventBase).toPromise();
	}

	updateEventBase(eventBaseId: number, updateEventBase: UpdatedEventBase): Promise<void> {
		return this._http.put<void>(`${this.eventBasesUrl}/${eventBaseId}`, updateEventBase).toPromise();
	}

	archiveEventBase(eventBaseId: number): Promise<void> {
		return this._http.delete<void>(`${this.eventBasesUrl}/${eventBaseId}`).toPromise();
	}
}
